<template>
  <ul :class="bullet?bullet:''">
    <li v-for="(item, index) in lista" :key="index">
      <p v-html="item"></p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    lista: {
      type: Array,
      required: true
    },
    bullet: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
.application.theme--light {
  &.light {
    ul {
      &.bullet-dav {
        list-style-image: url("../../assets/logos-icons/bullet-dav-2.png");
      }
      &.bullet-dav-ok {
        list-style-image: url("../../assets/logos-icons/bullet-dav-ok.png");
      }
      &.bullet-dav-ok-2 {
        list-style-image: url("../../assets/logos-icons/bullet-dav-ok-red.png");
      }
    }
  }
  &.dark {
    ul {
      &.bullet-dav {
        list-style-image: url("../../assets/logos-icons/bullet-dav-1.png");
      }
      &.bullet-dav-ok {
        list-style-image: url("../../assets/logos-icons/bullet-dav-ok.png");
      }
      &.bullet-dav-ok-2 {
        list-style-image: url("../../assets/logos-icons/bullet-dav-ok-red.png");
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// ui-list.vue?abaf5a0a